import { IJob2Action, IJob2s } from "./job2Interface";

const jobListenDefault = {}

function job2Reducer(state: IJob2s = jobListenDefault, action: IJob2Action): IJob2s {
    switch (action.type) {
        case "JOB2_UPDATE":
            return action.payload ? action.payload : {}
        case "JOB2_CLEAR":
            return {};
        case "JOB2_ADD":
            return Object.assign({}, state, action.payload);
        case "PROGRESS_CLEAR":
            return jobListenDefault;
        default:
            return state;
    }
}


export default job2Reducer;